/**
 * Analytics identifiers for FARM & RANCH WELDING PLANS™.
 * Leave a value empty to keep that integration switched off.
 */
export const META_PIXEL_ID = '4649947928574971'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
